<template lang="pug">
    .page(ref='galleryPage')
      section.pb-3
        b-container.text-center
          h1 Our Seasonal Collection Of Hand-selected Pieces
      section.p-0
        .container.pt-2
          b-form-row.row.my-0(inline)
            b-col.mb-2(cols="12")
              b-form-input(name="search", v-model="filter.search_string", placeholder='Search by artist, title, style etc...')
            //b-col.mb-2.text-right(cols="2")
              b-button.mx-1.btn-dark(@click="getArt(true)")
                loader(size="sm")
                span FIND
          b-form-row.row.my-0(inline)
              b-col.mb-2(cols="6", md="3")
                v-select.mb-1(:options="art_forms", label='title', :reduce="item => item.title", placeholder='FORM', v-model='filter.form')
              b-col.mb-2(cols="6", md="3")
                v-select.mb-1(:options="art_styles", label='title', :reduce="item => item.title", placeholder='STYLE', v-model='filter.style')
              b-col.mb-2(cols="6", md="3")
                v-select.mb-1(:options="artMedia", label='title', placeholder='MEDIUM', :reduce="item => item.title",  v-model='filter.medium')
              b-col.mb-2(cols="6", md="3")
                v-select.mb-1(:options="art_subjects", label='title', :reduce="item => item.title", placeholder='SUBJECT',  v-model='filter.subject')
          .row.p-3
            .col-4.pt-3.text-left.d-flex.align-items-center
              .mx-2(@click="theatreMode = !theatreMode", :class="{ 'text-muted' : theatreMode }")
                font-awesome-icon(icon="th-large")
            .col-8.pt-3.text-right.d-flex.align-items-center.justify-content-end
              b-button.mx-1.btn-dark(@click="getArt(true)")
                loader(size="sm")
                span FIND
              b-button.btn-outline.mx-1(@click='clearFilters') CLEAR
      masonry.gallery(:cols="{default: 4, 1000: 3, 700: 2, 400: 1}", :class="{'theatre-mode': theatreMode}")
        .piece(v-for="piece in art", :key='piece.id')
          .btnOpenPiece(ref="imageContainer", @click="openPiece(piece)", :class="piece.isDummy?'dummyPiece':'realPiece'")
            img.thumbnail( v-show="piece.thumbnail_url", :src="getImageUrl(piece.thumbnail_url, imageWidth)", @load="loaded(piece)", :alt="`${piece.title} by ${piece.artist}`")
            .placeholder-img.bg-light(v-if="piece.isDummy || !piece.loaded")
              b-spinner(type="grow")
          .info.p-2(v-if="!piece.isDummy")
            .row
              .col-8
                span.text-dark {{ piece.artist }}
              .col-4.text-right
                span.text-dark {{ formatRands(piece.price) }}
            .row
              .col-7
                p.my-1.text-dark {{ `${piece.title} ${piece.is_test ? '(Test)' : ''}` }}
              .col-5.text-right(v-if="piece.is_rentable")
                p.m-0.small {{ `Rent for ${formatRands(piece.price_rental)}/m` }}
            .row
              .col-10
                p.m-0.small {{ `${piece.height}x${piece.width}cm | ${piece.medium}` }}
              .col-2.text-right
                .favourite(v-if="!loveTest(piece)", @click="lovePiece(piece)")
                  font-awesome-icon(icon="heart")
                .favourite.love(v-else="", @click="unlovePiece(piece)")
                  font-awesome-icon(icon="heart")

          .info.p-2(v-else="")
            .row
              .col-8
                content-loader(:height="20")
              .col-4
                content-loader(:height="40")
              .col-12
                content-loader(:height="12")
      section.text-center(v-if="!alert.loading && art.length === 0")
        nothing(text="NOTHING TO SHOW")
        //- img.logo(src="@/assets/images/branding/logo_icon_grey.svg")
        //- p.mt-5 No items
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import Vue from 'vue';
import router from '@/router';

export default {
  components: {
  },
  mixins: [standardMix],
  metaInfo() {
    const baseTitle = 'Gallery';
    const baseMeta = [
      {
        name: 'description',
        content: 'Discover Wall Collective\'s curated selection of original artworks from emerging and established South African artists. Browse paintings, prints, photography and sculptures available for purchase or rental.',
      },
      {
        name: 'keywords',
        content: 'art gallery, south african art, original artwork, paintings, prints, photography, sculptures, art rental, buy art online, emerging artists, established artists',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:site_name',
        content: 'Wall Collective',
      },
      {
        property: 'og:image',
        content: 'https://wallcollective.co.za/og-gallery.jpg',
      },
      {
        property: 'og:image:width',
        content: '1200',
      },
      {
        property: 'og:image:height',
        content: '630',
      },
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:site',
        content: '@wall_collective',
      },
    ];

    // Dynamic title and description based on active filters
    let dynamicTitle = baseTitle;
    let dynamicDescription = 'Discover Wall Collective\'s curated selection of original artworks from emerging and established South African artists.';

    const activeFilters = [];
    if (this.filter.form) activeFilters.push(this.filter.form);
    if (this.filter.style) activeFilters.push(this.filter.style);
    if (this.filter.medium) activeFilters.push(this.filter.medium);
    if (this.filter.subject) activeFilters.push(this.filter.subject);

    if (activeFilters.length > 0) {
      dynamicTitle = `${activeFilters.join(' ')} Art Gallery`;
      dynamicDescription = `Browse our collection of ${activeFilters.join(', ')} artworks. ${dynamicDescription}`;
    }

    if (this.filter.search_string) {
      dynamicTitle = `Search: ${this.filter.search_string} | Gallery`;
      dynamicDescription = `Search results for "${this.filter.search_string}". ${dynamicDescription}`;
    }

    return {
      title: dynamicTitle,
      meta: [
        ...baseMeta,
        {
          name: 'description',
          content: dynamicDescription,
        },
        {
          property: 'og:title',
          content: `${dynamicTitle} | Wall Collective`,
        },
        {
          property: 'og:description',
          content: dynamicDescription,
        },
        {
          property: 'og:url',
          content: `https://wallcollective.co.za${this.$route.path}`,
        },
        {
          name: 'twitter:title',
          content: `${dynamicTitle} | Wall Collective`,
        },
        {
          name: 'twitter:description',
          content: dynamicDescription,
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: `https://wallcollective.co.za${this.$route.path}`,
        },
      ],
    };
  },
  data() {
    return {
      imageWidth: 300,
      art_forms: [],
      art_media: [],
      art_styles: [],
      art_subjects: [],
      art: [],
      dummyArt: [
        { id: 'a', title: 'dummy', isDummy: true },
        { id: 'b', title: 'dummy', isDummy: true },
        { id: 'c', title: 'dummy', isDummy: true },
        { id: 'd', title: 'dummy', isDummy: true },
      ],
      lovedArt: [],
      showFilter: true,
      collapsed: true,
      filter: {
        form: '',
        style: '',
        medium: '',
        subject: '',
        artist_id: 'All',
        limit: 5,
        offset: 0,
        status: ['available', 'rented', 'reserved'],
        // price_high: 0,
      },
      noMore: true,
      theatreMode: false,
    };
  },
  computed: {
    artMedia() {
      const artForm = this.art_forms.find(item => item.title === this.filter.form);
      if (artForm) {
        const media = this.art_media.filter(item => item.art_form_id === artForm.id);
        return media;
      }
      return [];
    },
    structuredData() {
      if (!this.art || this.art.length === 0) return null;

      const validArt = this.art.filter(item => !item.isDummy);
      if (validArt.length === 0) return null;

      return {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: 'Wall Collective Art Gallery',
        description: 'Curated collection of original artworks from South African artists',
        url: `https://wallcollective.co.za${this.$route.path}`,
        mainEntity: {
          '@type': 'ItemList',
          numberOfItems: validArt.length,
          itemListElement: validArt.map((piece, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            item: {
              '@type': 'VisualArtwork',
              name: piece.title,
              artist: {
                '@type': 'Person',
                name: piece.artist,
              },
              image: piece.thumbnail_url,
              description: piece.description || `${piece.title} by ${piece.artist}`,
              artMedium: piece.medium,
              artform: piece.form,
              width: {
                '@type': 'QuantitativeValue',
                value: piece.width,
                unitCode: 'CMT',
              },
              height: {
                '@type': 'QuantitativeValue',
                value: piece.height,
                unitCode: 'CMT',
              },
              offers: piece.price ? {
                '@type': 'Offer',
                price: piece.price,
                priceCurrency: 'ZAR',
                availability: piece.status === 'available' ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
                url: `https://wallcollective.co.za/art/${piece.id}/${this.kebabMe(piece.title)}`,
              } : undefined,
            },
          })),
        },
      };
    },
    breadcrumbData() {
      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: 'https://wallcollective.co.za',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Gallery',
            item: 'https://wallcollective.co.za/gallery',
          },
        ],
      };
    },
  },
  methods: {
    loaded(piece) {
      const newPiece = { ...piece };
      newPiece.loaded = true;
      const index = this.art.findIndex(item => item.id === piece.id);
      Vue.set(this.art, index, newPiece);
    },
    clearFilters() {
      this.filter.form = '';
      this.filter.style = '';
      this.filter.medium = '';
      this.filter.subject = '';
      this.filter.price_high = 'All';
      this.filter.artist_id = 'All';
      this.filter.offset = 0;
      this.filter.search_string = '';
      this.updateURLParameters();
      this.getArt(true);
    },
    updateURLParameters() {
      const query = {};
      if (this.filter.form) query.form = this.kebabMe(this.filter.form);
      if (this.filter.style) query.style = this.kebabMe(this.filter.style);
      if (this.filter.medium) query.medium = this.kebabMe(this.filter.medium);
      if (this.filter.subject) query.subject = this.kebabMe(this.filter.subject);
      if (this.filter.search_string) query.q = this.filter.search_string;

      // Only update if query actually changed
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ name: 'gallery', query }).catch(() => {});
      }
    },
    // getColumnWidth() {
    //   if (!this.$refs) {
    //     return 0; // Default width if ref is not available
    //   }
    //   const width = this.$refs.thumbnailImage.clientWidth;
    //   console.log('Column width:', width);
    //   return width;
    // },
    async getArt(reset) {
      try {
        if (reset) {
          this.art = [];
          this.filter.offset = 0;
          this.noMore = false;
          this.updateURLParameters();
        }
        this.loading();
        this.addDummies();
        if (this.account.loggedIn) {
          this.lovedArt = await apiService.getLovedArt(this.profileId, { limit: 100, offset: 0 });
          console.log(this.account.user);
          this.filter.is_test = this.account.user.is_test;
        }
        const newArt = await apiService.getArt(this.filter);
        if (newArt.length === 0) {
          this.noMore = true;
        }
        this.removeDummies();
        // eslint-disable-next-line no-restricted-syntax
        for (const item of newArt) {
          this.art.push(item);
        }
        this.clear();
        this.filter.offset += this.filter.limit;
      } catch (error) {
        this.error(error);
        this.noMore = true;
        this.removeDummies();
      }
    },
    openPiece(piece) {
      const routeData = this.$router.resolve({ name: 'Piece', params: { pieceId: piece.id, pieceTitle: this.kebabMe(piece.title) } });
      window.open(routeData.href, '_blank');
      // Navigate
      // router.push({ name: 'Piece', params: { pieceId: piece.id, pieceTitle: this.kebabMe(piece.title) } });
    },
    async lovePiece(piece) {
      if (this.account.loggedIn) {
        try {
          await apiService.lovePiece(this.profileId, piece.id);
          this.lovedArt.push(piece);
        } catch (error) {
          this.error('Something went wrong');
        }
      } else {
        router.push({ name: 'login' });
      }
    },
    async unlovePiece(piece) {
      try {
        await apiService.unlovePiece(this.profileId, piece.id);
        this.lovedArt = this.lovedArt.filter(item => item.id !== piece.id);
      } catch (error) {
        this.error('Something went wrong');
      }
    },
    loveTest(piece) {
      return this.lovedArt.some(item => item.id === piece.id);
    },
    onScroll() {
      const scrollBottom = document.documentElement.scrollTop + document.documentElement.clientHeight;
      const galleryHeight = this.$refs.galleryPage.clientHeight;
      if ((scrollBottom >= galleryHeight) && !this.alert.loading) {
        this.getArt();
      }
    },
    addDummies() {
      this.removeDummies();
      this.art.push(...this.dummyArt);
    },
    removeDummies() {
      this.art = this.art.filter(item => !item.isDummy);
    },
    updateStructuredData() {
      // Remove existing structured data scripts
      const existingScripts = document.querySelectorAll('script[type="application/ld+json"][data-vue-meta]');
      existingScripts.forEach(script => script.remove());

      // Add artwork structured data if available
      if (this.structuredData) {
        const artworkScript = document.createElement('script');
        artworkScript.type = 'application/ld+json';
        artworkScript.setAttribute('data-vue-meta', 'true');
        artworkScript.textContent = JSON.stringify(this.structuredData);
        document.head.appendChild(artworkScript);
      }

      // Add breadcrumb structured data
      const breadcrumbScript = document.createElement('script');
      breadcrumbScript.type = 'application/ld+json';
      breadcrumbScript.setAttribute('data-vue-meta', 'true');
      breadcrumbScript.textContent = JSON.stringify(this.breadcrumbData);
      document.head.appendChild(breadcrumbScript);
    },
  },
  watch: {
    noMore(done) {
      if (done) {
        window.removeEventListener('scroll', this.onScroll);
      } else {
        window.addEventListener('scroll', this.onScroll);
      }
    },
    art: {
      handler() {
        this.$nextTick(() => {
          this.updateStructuredData();
        });
      },
      deep: true,
    },
    'filter.form': {
      handler() {
        this.$meta().refresh();
      },
    },
    'filter.style': {
      handler() {
        this.$meta().refresh();
      },
    },
    'filter.medium': {
      handler() {
        this.$meta().refresh();
      },
    },
    'filter.subject': {
      handler() {
        this.$meta().refresh();
      },
    },
    'filter.search_string': {
      handler() {
        this.$meta().refresh();
      },
    },
  },
  async created() {
    // Process route param filters
    const { form, style, medium, subject, artist, q } = this.$route.query;
    this.filter.form = this.unKebabMe(form) || '';
    this.filter.medium = this.unKebabMe(medium) || '';
    this.filter.style = this.unKebabMe(style) || '';
    this.filter.subject = this.unKebabMe(subject) || '';
    this.filter.artist_id = artist || '';
    this.filter.search_string = q || '';
    this.noMore = false;
    // TEMP Only loading art for logged in user
    await this.getArt();
    const filters = await apiService.getFilters();
    this.art_forms = filters.art_forms;
    this.art_media = filters.art_media;
    this.art_styles = filters.art_styles;
    this.art_subjects = filters.art_subjects;
    // Calculate container widths to get correct images
    const element = this.$refs.imageContainer[0];
    if (element) {
      const elementWidth = element.clientWidth;
      this.imageWidth = elementWidth > 0 ? elementWidth : 300; // Fallback width if ref is not available
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    // Clean up structured data
    const existingScripts = document.querySelectorAll('script[type="application/ld+json"][data-vue-meta]');
    existingScripts.forEach(script => script.remove());
  },
  mounted() {
    // const element = this.$refs.thumbnailImage;
    // if (element) {
    //   const width = element.clientWidth; // or element.offsetWidth for full width including padding and border
    //   console.log('Element width:', width);
    // } else {
    //   console.warn('Thumbnail image ref not found');
    // }
    this.$nextTick(() => {
      this.updateStructuredData();
    });
  },
};
</script>

<style lang="scss" scoped>

  .v-select {
    text-transform: uppercase;
    // border: 1px solid black;
    font-family: $font-body;
    font-size: 16px;
    border: none;
    .vs__dropdown-toggle {
      border: none !important;
    }
  }
  .gallery {
    background-color: white;
    padding: 10px;
    transition: all ease-in 0.5s;
    .piece {
    cursor: pointer;
      transition: all ease-in 0.5s;
      margin: 15px;
      opacity: 1;
      .thumbnail {
        width: 100%;
      }
      .placeholder-img {
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .info {
        transition: all ease-in 0.5s;
        .favourite {
          cursor: pointer;
          color: lightgray;
          &.love {
            // color: rgb(250, 195, 0);
            color: black;
          }
        }
      }
    }
    &.theatre-mode {
      padding: 0;
      .piece {
        margin: 0;
      }
      .info {
        max-height: 0;
        overflow: hidden;
        padding: 0 !important;
      }
    }
  }
  .logo {
    width: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Gallery.vue